import { injectable, inject } from 'inversify';
import { ObjectCompletionHandlerInterface } from './object-completion-handler-interface';
import { SectionInteraction, SectionCompletion } from '@/app/statistics/section/section-progress';
import { SectionProgressUtils, SectionProgressUtilsSymbol } from '@/app/statistics/section/section-progress-utils';
import { createInteractionId } from '../section/section-interaction-utils';

export const FLIPCARD_TYPE: string = 'flipcard';

@injectable()
export class FlipcardItemsCompletionHandler implements ObjectCompletionHandlerInterface {

  @inject(SectionProgressUtilsSymbol)
  private sectionProgressUtils: SectionProgressUtils;

  public calculateDefaultInteractions($container: any|null): SectionInteraction[] {
    let interactions: SectionInteraction[] = [];
    $('.flipcard', $container).each((index: number, element: any) => {
      const $element: any = $(element);
      const id: string = createInteractionId(FLIPCARD_TYPE, $element.attr('id'));
      const title: string = $element.attr('data-title') || 'flipcard-component';

      const items: { [id: string]: boolean } = {};
      $('.card-wrapper', $element).each((itemIndex: number) => {
        const itemId: string = this.sectionProgressUtils.createItemId(id, itemIndex);
        items[itemId] = false;
      });

      interactions = [...interactions, {
        id,
        title,
        type: FLIPCARD_TYPE,
        completed: false,
        items
      }];
    });

    return interactions;
  }

  public setInteraction(completion: SectionCompletion, interaction: any): SectionCompletion {
    if (interaction.type && interaction.type === FLIPCARD_TYPE) {
      const flipcardId: string = interaction.id;
      const itemId: string = this.sectionProgressUtils.createItemId(flipcardId, interaction.index);
      completion = this.sectionProgressUtils.setInteractionItemCompleted(completion, flipcardId, FLIPCARD_TYPE, itemId);
    }

    return completion;
  }
}
